<div
  role="region"
  [attr.aria-label]="'PayPal payment section'"
  [attr.aria-describedby]="'paypal-instructions'"
>
  <div
    id="paypal-instructions"
    class="visually-hidden"
    role="status"
  >
    PayPal payment section. You can pay securely using your PayPal account or credit card.
  </div>
  <ng-container *calioLightDomProjection>
    @if (payPalConfig) {
      <ngx-paypal
        [config]="payPalConfig"
        (scriptLoaded)="onPaypalScriptLoaded($event)"
        role="application"
        [attr.aria-label]="'PayPal payment button'"
      />
    }
  </ng-container>
</div>
